import React, { useMemo } from "react";
import Plot from "react-plotly.js";
import DataTable from "./DataTable";

/** Renders the `matrix` envelope field: either a rows/cols numeric grid
 *  (heatmap + table) or, when `cols` is empty, a flat list of row-objects. */
function MatrixView({ matrix, heatmap, title }) {
  const isGrid = matrix && Array.isArray(matrix.cols) && matrix.cols.length > 0;

  const flatRows = useMemo(() => {
    if (!matrix) return [];
    if (isGrid) {
      return matrix.rows.map((r, i) => {
        const row = { " ": r };
        matrix.cols.forEach((c, j) => { row[c] = matrix.data[i][j]; });
        return row;
      });
    }
    return Array.isArray(matrix.data) ? matrix.data : [];
  }, [matrix, isGrid]);

  if (!matrix) return null;

  if (!isGrid) {
    return <DataTable rows={flatRows} title={title} exportName={title} />;
  }

  return (
    <div className="analysis-matrix-block">
      {heatmap && (
        <Plot
          data={[{
            x: matrix.cols,
            y: matrix.rows,
            z: matrix.data,
            type: "heatmap",
            colorscale: "RdBu",
            reversescale: true,
          }]}
          layout={{ title, autosize: true, margin: { t: title ? 40 : 10 } }}
          style={{ width: "100%", height: "360px" }}
          useResizeHandler
        />
      )}
      <DataTable rows={flatRows} title={heatmap ? null : title} exportName={title} />
    </div>
  );
}

export default MatrixView;
